<div class="list">
  <p class="name mb-2">Envie a documentação necessária</p>
  <p class="description">
    Para obter informações sobre o envio, entre em contato com o beneficiário.
  </p>

  <div class="d-flex align-content-center mt-4">
    <div *ngIf="finality?.id == 18 || finality?.id == 28" class="ball-number">
      <p class="m-0">1</p>
    </div>
    <p class="sub-name m-0">Anexe a documentação que suporta sua operação.</p>
  </div>

  <input
    #fileSelector
    type="file"
    [multiple]="true"
    style="display: none"
    (change)="selectFile($event)"
  />
  <div
    *ngIf="selectedFiles.length == 0"
    appDrag
    (files)="filesDropped($event)"
    (click)="fileSelector.click()"
    class="row glass tappable"
  >
    <div class="col-12">
      <p class="text-center mb-5">
        <mat-icon svgIcon="cloud-upload"></mat-icon>
      </p>
      <p class="upload-disclaimer text-center mb-1">
        Arraste a ordem para cá ou
        <span class="upload-disclaimer highlighted"
          >busque nos seus arquivos</span
        >
      </p>
      <p class="description text-center mb-0">
        Apenas os formatos .pdf .doc .png e .jpg são aceitos
      </p>
    </div>
  </div>

  <div *ngIf="selectedFiles.length > 0" class="row glass filled">
    <div class="col-12">
      <ul>
        <div
          class="list-files"
          *ngFor="let file of selectedFiles; let i = index"
        >
          <div class="file-name">
            <mat-icon svgIcon="file"></mat-icon>
            <span [matTooltip]="file.file.name">{{ file.file.name }}</span>
          </div>

          <div class="btn-remove-file">
            <button (click)="removeFile(i)" mat-button class="button danger">
              Remover documento
            </button>
          </div>
        </div>

        <div
          class="d-flex justify-content-between align-items-center add-document"
        >
          <span class="btn-blue" (click)="fileSelector.click()"
            >Adicionar mais documentos</span
          >
          <p class="description text-center mb-0">
            Apenas os formatos .pdf .doc .png e .jpg são aceitos
          </p>
        </div>
      </ul>
    </div>
  </div>

  <ng-container *ngIf="finality?.id == 18 || finality?.id == 28">
    <div class="d-flex align-content-center mt-4 mb-3">
      <div class="ball-number">
        <p class="m-0">2</p>
      </div>
      <p class="sub-name m-0">Informações da Declaração de Importação.</p>
    </div>

    <p class="description mb-3">
      A DI é apresentada à Receita Federal pelo importador ou seu representante
      legal (como um despachante aduaneiro) e contém informações relevantes para
      o processo de importação.
    </p>

    <div class="row">
      <div class="col-md-6">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Informar protocolo da DI (opcional)</mat-label>
          <input
            matInput
            [(ngModel)]="diProtocol"
            type="text"
            class=""
            name="name"
          />
        </mat-form-field>
      </div>
      <div class="col-md-6">
        <mat-form-field class="w-100" appearance="outline">
          <mat-label>Informar número da DI (opcional)</mat-label>
          <input
            matInput
            [(ngModel)]="diNumber"
            type="text"
            class=""
            name="name"
          />
        </mat-form-field>
      </div>
    </div>
  </ng-container>

  <div class="spacer"></div>

  <div class="buttons border-grey-light">
    <div class="cols d-flex">
      <button
        (click)="back()"
        type="button"
        class="btn btn-block btn-dark-primary-outline-back"
        type="button"
      >
        Voltar
      </button>
      <button
        [disabled]="selectedFiles.length == 0 || loading"
        (click)="submit()"
        type="submit"
        class="btn btn-block mt-0 ml-3"
        [ngClass]="
          companyId ? 'btn-dark-primary-blue' : 'btn-dark-primary-blue-pf'
        "
        type="button"
      >
        Finalizar
        <span class="spinner-border spinner-border-sm" *ngIf="loading"></span>
      </button>
    </div>
  </div>
</div>
